var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 37,
    viewBox: "0 0 58 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 0.5H5C3.82649 0.5 2.68979 0.907305 1.84232 1.64884C0.992722 2.39224 0.5 3.41595 0.5 4.5V32.5C0.5 33.584 0.992722 34.6078 1.84232 35.3512C2.68979 36.0927 3.82649 36.5 5 36.5H53C54.1735 36.5 55.3102 36.0927 56.1577 35.3512C57.0073 34.6078 57.5 33.584 57.5 32.5V4.5C57.5 3.41595 57.0073 2.39224 56.1577 1.64884C55.3102 0.907305 54.1735 0.5 53 0.5ZM29 15.7805L11.1915 5H46.8085L29 15.7805ZM5.5 32V6.97979L27.6006 20.3624C28.0168 20.6151 28.5049 20.7471 29 20.7471C29.4951 20.7471 29.9832 20.6151 30.3994 20.3624L52.5 6.97979V32H5.5Z",
    fill: "#F8E9D2",
    stroke: "#F8E9D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.3a012aa33408651937e7196d2b5be936.svg";
export { ForwardRef as ReactComponent };